module.exports = __webpack_public_path__ + "img/ch39.07bf6b26.png";